import { render, staticRenderFns } from "./textarea.component.vue?vue&type=template&id=963a2e4e&scoped=true&"
import script from "./textarea.component.vue?vue&type=script&lang=ts&"
export * from "./textarea.component.vue?vue&type=script&lang=ts&"
import style0 from "./textarea.component.vue?vue&type=style&index=0&id=963a2e4e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a2e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
